export var AnnouncementType;
(function (AnnouncementType) {
    AnnouncementType["SYSTEM"] = "system";
    AnnouncementType["GAME"] = "game";
    AnnouncementType["FINANCE"] = "finance";
    AnnouncementType["ACTIVITY"] = "activity";
    AnnouncementType["STAFF"] = "staff";
})(AnnouncementType || (AnnouncementType = {}));
//# sourceMappingURL=AnnouncementType.js.map